var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.889H0V5.55566H20V8.889Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22222 2.22266H17.7778C19.0035 2.22266 20 3.2178 20 4.44488V5.55599H0V4.44488C0 3.2178 0.994792 2.22266 2.22222 2.22266ZM2.22222 17.7782C0.994792 17.7782 0 16.7831 0 15.556V8.88932H20V15.556C20 16.7831 19.0052 17.7782 17.7778 17.7782H2.22222ZM6.63542 13.6115C6.63542 13.458 6.75979 13.3338 6.91319 13.3338H11.8819C12.0353 13.3338 12.1597 13.458 12.1597 13.6115L12.2222 14.1671C12.2222 14.3205 12.0978 14.4449 11.9444 14.4449H6.94444C6.79167 14.4449 6.66667 14.3199 6.66667 14.1671L6.63542 13.6115ZM2.46875 13.3338C2.31535 13.3338 2.19097 13.458 2.19097 13.6115L2.22222 14.1671C2.22222 14.3199 2.34653 14.4449 2.5 14.4449H5.27778C5.43056 14.4449 5.55556 14.3199 5.55556 14.1671L5.52431 13.6115C5.52431 13.458 5.39993 13.3338 5.24653 13.3338H2.46875Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.ce130230f1e67c33434898c89f3f9fe5.svg";
export { ForwardRef as ReactComponent };